export default "__VITE_ASSET__a5e5f096__"